import React from "react";
import AboutHero from "./AboutHero";
import OurStory from "./OurStory";
import MissionVision from "./MissionVision";
import CoreValues from "./CoreValues";
import OurImpact from "./OurImpact";
import Explore from "./Explore";

function About() {
  return (
    <div id="about">
      <AboutHero />
      <OurStory />
      <MissionVision />
      <CoreValues />
      <OurImpact />
      <Explore />
    </div>
  );
}

export default About;
